import { render, staticRenderFns } from "./UsersEditor.vue?vue&type=template&id=894a5374&scoped=true&"
import script from "./UsersEditor.vue?vue&type=script&lang=ts&"
export * from "./UsersEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894a5374",
  null
  
)

export default component.exports